<template>
  <div class="c-masthead">
    <div class="c-masthead__inner">
      <sc-image v-if="fields && fields.image" :media="fields.image" class="c-masthead__icon" />
      <sc-text tag="h1" v-if="fields && fields.heading" :field="fields.heading" />
      <sc-text tag="h2" v-if="fields && fields.subheading" :field="fields.subheading" />
      <sc-text tag="h3" v-if="fields && fields.subsubheading" :field="fields.subsubheading" />
      <sc-text
        tag="div"
        class="c-masthead__label"
        v-if="fields && fields.label"
        :field="fields.label"
      />
      <sc-rich-text v-if="fields && fields.lead" :field="fields.lead" class="c-masthead__lead" />
      <sc-link
        v-if="fields && fields.cta1 && fields.cta1.value.text"
        :field="fields.cta1"
        class="c-cta--primary"
        :class="fields.cta1.value.class"
      />
      <sc-link
        v-if="fields && fields.cta2 && fields.cta2.value.text"
        :field="fields.cta2"
        class="c-cta--primary second"
        :class="fields.cta2.value.class"
      />
    </div>
  </div>
</template>

<script>
import { Text, RichText, Link, Image } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Masthead-With-Label',
  components: {
    ScText: Text,
    ScLink: Link,
    ScImage: Image,
    ScRichText: RichText
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.c-masthead {
  @include padding-y(5rem, 4rem);
  color: $white;
  background: linear-gradient(
    169deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 59, 92, 1) 20%,
    rgba(0, 134, 191, 1) 100%
  );

  @include tablet-up {
    @include padding-y(5rem);
  }

  &__inner {
    @include padding-x-thin;
  }

  &__inner {
    h1,
    h2,
    h3,
    p,
    span {
      color: $white;
    }

    h1,
    h2 {
      -webkit-text-fill-color: $white;
    }

    h1 {
      margin-top: 0;
    }

    h2 {
      margin-bottom: 3.2rem;
    }

    h3 {
      @include phone-only {
        font-size: 2rem;
        line-height: 2.6rem;
      }
    }
  }

  &__icon {
    margin-bottom: 2rem;
  }

  &__label {
    display: inline-block;
    border-left: 0.4rem solid $orange;
    background: $box-gray;
    padding: 0 1.2rem 0.2rem 1.2rem;
    @include font-styles('Arial Narrow', 2rem, 600, normal, normal, 0, $dark-blue);
    text-transform: uppercase;
  }

  &__lead {
    margin-top: 1.6rem;
    margin-bottom: 4rem;
  }

  .second {
    @include tablet-up {
      margin-left: 4rem;
    }
  }
}
</style>
